<template>
    <div style="height:100%" class="content">
        <div id="Contain">
          <div id="overview" class="leaflet-control-minimap"></div>
        </div>
    <div id="loadingOverlay"><h1>Loading........</h1></div>
    </div>
</template>
<script>
import util from '../../components/util'
import CesiumNavigation from "cesium-navigation-es6";
import * as L from 'leaflet'
import CesiumOverviewMapControl from "../../js/OverviewMapControl"
export default {
    data () {
        return {
        viewer:null
        }
    },
    mounted(){
    var loa=document.getElementById('loadingOverlay');
       setTimeout(()=>{
           loa.style.display="none";
       },4000);
       this.init();
       this.initOverview(this.viewer);
    },
    methods:{
      init(){
          this.viewer=util.getViewer('Contain',{
            shouldAnimate: true,
            imageryProvider:new Cesium.UrlTemplateImageryProvider({
            url: 'https://server.arcgisonline.com/arcgis/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'
             })
          });
            this.viewer.scene.globe.depthTestAgainstTerrain = true;
            var options = {};
            options.defaultResetView = Cesium.Cartographic.fromDegrees(110, 30, 2000000);
            options.enableCompass= true;
            options.enableZoomControls= true;
            options.enableDistanceLegend= true;
            options.enableCompassOuterRing= true;
            options.position="topleft";
            CesiumNavigation(this.viewer, options);
            this.viewer.camera.flyTo({
                destination : Cesium.Cartesian3.fromDegrees(117.227308,31.82057, 1500.0),
                orientation: {
                    heading : Cesium.Math.toRadians(360.0),
                    pitch : Cesium.Math.toRadians(-90),
                    roll : 0.0
                },
                duration:3
            });
      },
      initOverview(viewer) {
        var url = "http://mt0.google.cn/vt/lyrs=t,r&hl=zh-CN&gl=cn&x={x}&y={y}&z={z}";
        var layer = new L.TileLayer(url, {
            minZoom: 0,
            maxZoom: 20
        });
        var container = document.getElementById("overview");
        var options = {
            container: container,
            toggleDisplay: true,
            width: 150,
            height: 150,
            position: "topright",
            strings: { hideText: '隐藏鹰眼', showText: '显示鹰眼' },
            aimingRectOptions: {
                color: "#ff1100",
                weight: 3
            },
            shadowRectOptions: {
                color: "#0000AA",
                weight: 1,
                opacity: 0,
                fillOpacity: 0
            }
        };       
       var overviewCtr =new CesiumOverviewMapControl(viewer, layer, options);
     } 
    }
}
</script>
<style lang="stylus" scoped>
#Contain 
    height:100%;
    width:100%;
    margin:0;
    padding: 0;

#overview 
    z-index: 99998;
    width: 150px;
    height: 150px;
    position: absolute;
    right: 10px;
    top: 50px;

.content>>>.compass
    left:0;

 .content>>>.navigation-controls
    left:30px;
    background: rgba(47,53,60,.8);
    border: 1px solid rgba(255,255,255,.5);
</style>